import { Formato } from '../types/Dashboard';

const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const numero = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

// Valor de dashboard pelo `formato` do widget (moeda, número, percentual ou texto)
export function formatarValor(valor: number | string | undefined | null, formato: Formato = 'texto') {
  if (valor === undefined || valor === null || valor === '') return '';
  if (typeof valor === 'string' || formato === 'texto') return String(valor);
  if (formato === 'moeda') return moeda.format(valor);
  if (formato === 'percentual') return `${numero.format(valor)}%`;
  return numero.format(valor);
}

// Versão curta para eixos de gráfico: 1,2 mi / 350 mil
export function formatarCompacto(valor: number, formato: Formato = 'numero') {
  const abs = Math.abs(valor);
  const sinal = valor < 0 ? '-' : '';
  const prefixo = formato === 'moeda' ? 'R$ ' : '';
  let texto: string;
  if (abs >= 1_000_000) texto = `${numero.format(Math.round((abs / 1_000_000) * 10) / 10)} mi`;
  else if (abs >= 1_000) texto = `${numero.format(Math.round(abs / 1_000))} mil`;
  else texto = numero.format(Math.round(abs));
  const sufixo = formato === 'percentual' ? '%' : '';
  return `${sinal}${prefixo}${texto}${sufixo}`;
}
